import './index.scss'

export function Loader(){
    return( <div className="bouncing-loader">
    <div></div>
    <div></div>
    <div></div>
  </div>)
}